import { combineReducers } from "redux";

import contactsReducer from "./Contacts/reducer";

import layoutReducer from "./Layout/reducer";

// Calendar
import calendarReducer from "./Calendar/reducer";

//Chat
import chatReducer from "./Chat/reducer";

// //Invoices
import invoicesReducer from "./Invoices/reducer";

//register
import registerReducer from "./Auth/Register/reducer";

//login
import loginReducer from "./Auth/Login/reducer";

//project
import projectsReducer from "./Projects/reducer";

// // User Profile
import profileReducer from "./Auth/Profile/reducer";

import forgetPasswordReducer from "./Auth/Forgetpwd/reducer";

// Units
import unitsReducer from "./Units/reducer";

import unitsTypesReducer from "./UnitsTypes/reducer";

import usersReducer from "./User/reducer";

import unitsUsersReducer from "./UnitsUsers/reducer";

import tasksReducer from "./Tasks/reducer";

import toastReducer from "./toast/reducer";

import phasesReducer from "./Phases/reducer";

import financingReducer from "./financing/reducer";

import objectivesReducer from "./objectives/reducer";

import statusPointsReducer from "./StatusPoint/reducer";

import {khoziApi} from "../services/khozi";

const rootReducer = combineReducers({
  //contacts: contactsReducer,
  Layout: layoutReducer,
  //calendar: calendarReducer,
  //chat: chatReducer,
  //invoices: invoicesReducer,
  //register: registerReducer,
  login: loginReducer,
  //forgetPassword: forgetPasswordReducer,
  //projects: projectsReducer,
  profile: profileReducer,
  units: unitsReducer,
  unitsTypes: unitsTypesReducer,
  users: usersReducer,
  unitsUsers: unitsUsersReducer,
  toast: toastReducer,
  tasks: tasksReducer,
  phases: phasesReducer,
  financing: financingReducer,
  objectives: objectivesReducer,
  statusPoints: statusPointsReducer,
  [khoziApi.reducerPath]: khoziApi.reducer
});

export default rootReducer;
